
import React, { useState, useEffect } from 'react';
import './App.css';
import './Flashcards.css';
import './Hangman.css';
import './Mobile.css';
import Auth from './Auth';
import FlashcardsEnhanced from './FlashcardsEnhanced';
import HangmanGame from './HangmanGame';
import SpeedRound from './SpeedRound';
import DailyChallenge from './DailyChallenge';
import MarathonMode from './MarathonMode';

function App() {
  const [data, setData] = useState(null);
  const [view, setView] = useState('flashcards'); // 'flashcards', 'hangman', 'speedround', 'daily', 'marathon'
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    // Load data from embedded JSON (production) or API (development)
    const loadData = async () => {
      try {
        // Try to import the data file
        const dataModule = await import('./mcat_data.json');
        setData(dataModule.default || dataModule);
      } catch (error) {
        console.error("Failed to load data:", error);
        // Fallback: try API if in development
        if (window.location.hostname === 'localhost') {
          fetch('http://10.10.1.7:5555/api/data')
            .then(response => response.json())
            .then(data => setData(data))
            .catch(err => console.error("API fetch failed:", err));
        }
      }
    };
    loadData();
  }, []);

  // Handle authentication
  const handleAuthenticated = (email) => {
    setIsAuthenticated(true);
    setUserEmail(email);
  };

  // Show auth screen if not authenticated
  if (!isAuthenticated) {
    return <Auth onAuthenticated={handleAuthenticated} />;
  }

  return (
    <div className="App">
      <header className="App-header">
        <h1>MCAT Preparation</h1>
        <nav className="App-nav">
          <button onClick={() => setView('flashcards')} className={view === 'flashcards' ? 'active' : ''}>Flashcards</button>
          <button onClick={() => setView('hangman')} className={view === 'hangman' ? 'active' : ''}>Quiz</button>
          <button onClick={() => setView('speedround')} className={view === 'speedround' ? 'active' : ''}>⚡ Speed Round</button>
          <button onClick={() => setView('daily')} className={view === 'daily' ? 'active' : ''}>🌟 Daily</button>
          <button onClick={() => setView('marathon')} className={view === 'marathon' ? 'active' : ''}>🏃 Marathon</button>
        </nav>
      </header>
      <main className="App-main">
        {data ? (
          <div>
            {view === 'flashcards' ? (
              <FlashcardsEnhanced data={data} />
            ) : view === 'hangman' ? (
              <HangmanGame data={data} />
            ) : view === 'speedround' ? (
              <SpeedRound data={data} />
            ) : view === 'daily' ? (
              <DailyChallenge data={data} />
            ) : (
              <MarathonMode data={data} />
            )}
          </div>
        ) : (
          <p>Loading data...</p>
        )}
      </main>
    </div>
  );
}

export default App;
